import dayjs from 'dayjs';
import type { DocumentAlertParams } from '@services/document/types';

// eslint-disable-next-line import/prefer-default-export
export enum DOCUMENT {
  f30 = 'F30',
  f31 = 'F31',
  f30_1 = 'F30-1',
  prv = 'PRV',
}

export const isDocumentExpired = (expiresAt: string | undefined | null) => (
  expiresAt && dayjs().isAfter(dayjs(expiresAt))
);

export const isOnTime = (
  disableOutOfTime: boolean,
  lastUploadDay: number,
  monthSelected: string,
): boolean => {
  const currentDay = dayjs().date();
  // If the feature is disabled, return true
  if (disableOutOfTime) return true;

  const lastUploadMonth = dayjs().subtract(1, 'month').month();

  const formatSelectedDate = dayjs(monthSelected);
  const selectedMonth = formatSelectedDate.month();
  // Check if the current month matches the previous month
  if (selectedMonth !== lastUploadMonth) return false;
  // Compare the current day with the last upload day
  return currentDay <= lastUploadDay;
};

export const normalizeDocumentHolderType = (holderType?: string) => {
  if (!holderType) return undefined;
  if (holderType === 'Contract') return 'contract';
  if (holderType === 'ContractorWorker') return 'contractor_worker';
  return holderType;
};

export const getDocumentHolderTagId = (holderType?: string, holderId?: number | string) => {
  if (!holderType || !holderId) return undefined;
  return `${normalizeDocumentHolderType(holderType)}-${holderId}`;
};

export const isVehicleDocumentHolder = (holderType?: string | null) => (
  holderType === 'ContractorVehicle' || holderType === 'JobVehicle'
);

export type DocumentVehicleDetailSource = {
  holderType?: string | null;
  vehicle?: {
    plates?: string | null;
    externalId?: string | null;
    vehicleCategory?: { name?: string | null } | null;
  } | null;
};

export type DocumentVehicleDetailFields = {
  holderType?: string | null;
  plate?: string | null;
  code?: string | null;
  category?: string | null;
};

export const mapDocumentVehicleDetailFields = (
  source?: DocumentVehicleDetailSource | null,
): DocumentVehicleDetailFields => ({
  holderType: source?.holderType,
  plate: source?.vehicle?.plates,
  code: source?.vehicle?.externalId,
  category: source?.vehicle?.vehicleCategory?.name,
});

export const shouldShowDocumentVehicleFields = (
  holderType?: string | null,
  plate?: string | null,
) => isVehicleDocumentHolder(holderType) || Boolean(plate);

export type UpdateDocumentParams = Pick<DocumentAlertParams, 'id'> & Partial<DocumentAlertParams>;
